// extracted by mini-css-extract-plugin
export default {"placeholder":"OrganizationSuspended_placeholder__NgsXO","placeholderWrapper":"OrganizationSuspended_placeholderWrapper__w45gV","title":"OrganizationSuspended_title__tUlfS"};